module.exports = __webpack_public_path__ + "static/img/m_b_nodata.a453341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/m_b_nodata.png
// module id = D/2u
// module chunks = 1